import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { IMG_MM, IMG_BCBS, IMG_UMOJA, IMG_NMAAT } from "@/lib/images";
import { ExternalLink, HeartHandshake } from "lucide-react";

const partners = [
  {
    name: "Many Mothers",
    url: "https://manymothers.org/",
    logo: IMG_MM,
    desc: "Many Mothers' mission is to ensure that every baby in New Mexico has a healthy and happy start to life by offering compassionate home visiting, family-centered community and basic needs support.",
  },
  {
    name: "Blue Cross Blue Shield of New Mexico",
    url: "https://www.bcbsnm.com/about-us",
    logo: IMG_BCBS,
    desc: "We work with Blue Cross Blue Shield of New Mexico (BCBSNM). Through the BCBSNM Care Van program we make our vision a reality — the Care Van is a 30-foot mobile health clinic that travels statewide.",
  },
  {
    name: "Umoja ABQ",
    url: "https://www.umojaabq.org/about-us",
    logo: IMG_UMOJA,
    desc: "Our mission is to empower refugee women with tools and resources to enhance and develop their skills through education, so they can successfully integrate and become self-sufficient and independent in American society while maintaining their cultural values.",
  },
  {
    name: "New Mexico African American Tobacco Prevention Network",
    url: "https://nmaatp.com/",
    logo: IMG_NMAAT,
    desc: "NMAAT provides materials, information and education to businesses and schools about smoking cessation alternatives available to residents. They especially encourage everyone in the state to explore alternatives to smoking and vaping.",
  },
];

export default function Partners() {
  return (
    <div className="App">
      <Navbar />
      <section className="max-w-6xl mx-auto px-6 pt-32 pb-16">
        <p className="label text-sm uppercase tracking-[0.15em] text-[#78698A] font-semibold">Community</p>
        <h1 className="font-serif text-5xl text-[#2D2336] mt-3">Our Partners</h1>
        <p className="text-lg text-[#5C5166] mt-4 max-w-2xl">
          Utopia Dental Care is proud of the partnerships it has. We vow to uphold them while
          continuing to make more — creating a strong and vast dental community throughout New Mexico!
        </p>

        <div className="grid md:grid-cols-2 gap-8 mt-12" data-testid="partners-list">
          {partners.map((p, i) => (
            <div key={i} className="bg-white border border-[#E5DEEB] rounded-2xl overflow-hidden shadow-sm hover:shadow-md transition-shadow flex flex-col">
              {p.logo && (
                <div className="h-40 bg-white border-b border-[#E5DEEB] flex items-center justify-center p-8">
                  <img src={p.logo} alt={p.name} className="max-h-full max-w-[70%] w-auto object-contain" />
                </div>
              )}
              <div className="p-8">
                <HeartHandshake className="h-7 w-7 text-[#6B4C8A]" />
                <h3 className="font-serif text-2xl text-[#2D2336] mt-3">{p.name}</h3>
                <p className="text-[#5C5166] leading-relaxed mt-3">{p.desc}</p>
                <a href={p.url} target="_blank" rel="noopener noreferrer"
                  className="inline-flex items-center gap-1.5 text-[#6B4C8A] font-medium mt-4 hover:underline">
                  Learn more <ExternalLink className="h-4 w-4" />
                </a>
              </div>
            </div>
          ))}
        </div>
      </section>
      <Footer />
    </div>
  );
}
